import { observable, action, makeObservable, set } from 'mobx';

import { CheckType } from '../../shared/support/modelTypes';

export interface CheckFormStoreType {
	model: CheckType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude: Array<any>;
	selectedItems: Array<any>;
	requiredToFill: Array<{ predefinedName: string; property: string; relation: string }>;
	isFirstLoad: boolean;
	name: string;
	productItem: any;
	isSequenceNumberChangedManually: boolean;
	setValue(model: any, key: string, value: any): void;
}

class CheckFormStore implements CheckFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			filterInclude: observable,
			selectedItems: observable,
			requiredToFill: observable,
			isFirstLoad: observable,
			name: observable,
			productItem: observable,
			isSequenceNumberChangedManually: observable,
			setValue: action
		});
	}

	model = {
		archived: false,
		cashRegisterId: null,
		salesReportId: null,
		managerId: null,
		typeId: 'check_types.income',
		statusId: 'check_statuses.pending',
		closedAt: null,
		closed: false,
		sellerId: null,
		customerOrderId: null,
		cashRegisterShiftId: null,
		loyaltyCardId: null,
		couponId: null,
		discountsCalculated: false,
		ownerId: null,
		ownerType: null,
		partnerId: null,
		contractId: null,
		authorId: null,
		deleted: false,
		note: null,
		organizationId: null,
		posted: false,
		responsibleId: null,
		warehouseId: null,
		priceTypeId: null,
		amount: 0,
		sellerType: null,
		periodAt: null,
		type: {
			id: 'check_types.income',
			keyId: 'income',
			ownerId: 'check_types',
			name: { ru: 'Приход' },
			description: null,
			predefined: true,
			predefinedName: 'CheckTypesIncome',
			predefinedVersion: 0
		},
		status: {
			id: 'check_statuses.pending',
			keyId: 'pending',
			ownerId: 'check_statuses',
			name: { ru: 'Отложен' },
			description: null,
			predefined: true,
			predefinedName: 'CheckStatusesPending',
			predefinedVersion: 0
		},
		productItemList: [],
		productItems: [],
		markingItems: [],
		markingItemList: [],
		paymentItems: [],
		paymentItemList: [],
		prepayItems: [],
		prepayItemList: [],
		loyaltyPolicyItems: [],
		loyaltyPolicyItemList: [],
		bonusPointIncomeItems: [],
		bonusPointIncomeItemList: []
	};
	productItem = {};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	isSequenceNumberChangedManually = false;
	pluralName = 'checks';
	filterInclude = [
		'partner',
		'organization',
		'status',
		'contract',
		'priceType',
		'warehouse',
		'cashRegister',
		'cashRegisterShift',
		'markingItems',
		'paymentItems',
		'prepayItems',
		'loyaltyPolicyItems',
		'bonusPointIncomeItems',
		'type',
		{
			relation: 'productItems',
			scope: {
				include: ['unit', 'feature', 'serialNumber', 'product', 'validityPeriod', 'productSet']
			}
		}
	];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	requiredToFill = [
		{
			predefinedName: 'DefaultOrganization',
			property: 'organizationId',
			relation: 'organization'
		},
		{
			predefinedName: 'DefaultPriceType',
			property: 'priceTypeId',
			relation: 'priceType'
		},
		{
			predefinedName: 'DefaultWarehouse',
			property: 'warehouseId',
			relation: 'warehouse'
		}
	];
	isFirstLoad = true;
	name = 'OrmCheck';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const checkFormStore = new CheckFormStore();

export default CheckFormStore;
